import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getDriveResultsSummary } from '../../api/resultsApi';
import { FaChartBar } from 'react-icons/fa';

const ResultsDrivesPage = () => {
  const [drives, setDrives] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDrives = async () => {
      try {
        const res = await getDriveResultsSummary();
        setDrives(res.data);
      } catch (err) {
        console.error('Failed to fetch drive summaries', err);
      } finally {
        setLoading(false);
      }
    };
    fetchDrives();
  }, []);

  return (
    <div className="container-fluid p-0">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h3 className="fw-bold mb-1">Results & Analytics</h3>
          <p className="text-muted mb-0">Select a drive to view detailed student results.</p>
        </div>
      </div>

      <div className="card custom-card border-0 shadow-sm rounded-4 mb-4">
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead className="bg-light text-muted border-bottom-0">
              <tr>
                <th className="py-3 px-4 fw-semibold border-0 rounded-start">Drive Name</th>
                <th className="py-3 px-4 fw-semibold border-0">Date</th>
                <th className="py-3 px-4 fw-semibold border-0 text-center">Registered</th>
                <th className="py-3 px-4 fw-semibold border-0 text-center">Appeared</th>
                <th className="py-3 px-4 fw-semibold border-0 text-center">Qualified</th>
                <th className="py-3 px-4 fw-semibold border-0 text-center">Not Qualified</th>
                <th className="py-3 px-4 fw-semibold border-0 text-center">Avg Score</th>
                <th className="py-3 px-4 fw-semibold border-0 text-center">Pass %</th>
                <th className="py-3 px-4 fw-semibold border-0 text-end rounded-end">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="9" className="text-center py-4"><div className="spinner-border text-primary-custom"></div></td></tr>
              ) : drives.length === 0 ? (
                <tr><td colSpan="9" className="text-center py-4 text-muted">No drives found.</td></tr>
              ) : (
                drives.map(d => (
                  <tr key={d.id} className="border-bottom">
                    <td className="py-3 px-4 fw-bold">{d.name}</td>
                    <td className="py-3 px-4">{new Date(d.date).toLocaleDateString()}</td>
                    <td className="py-3 px-4 text-center">{d.registered}</td>
                    <td className="py-3 px-4 text-center">{d.appeared}</td>
                    <td className="py-3 px-4 text-center text-success fw-bold">{d.qualified}</td>
                    <td className="py-3 px-4 text-center text-danger">{d.notQualified}</td>
                    <td className="py-3 px-4 text-center">{d.averageScore}</td>
                    <td className="py-3 px-4 text-center fw-bold">{d.passPercentage}%</td>
                    <td className="py-3 px-4 text-end">
                      <Link to={`/admin/drives/${d.id}/results`} className="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center gap-2 float-end" style={{ width: 'fit-content' }}>
                        <FaChartBar /> View Results
                      </Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ResultsDrivesPage;
